// src/store/index.js
import {createStore} from 'vuex';

import user from "@/store/user";

export default createStore({
    modules: {
        // 用户配置
        user
    }
});
